{
  "version": "v1",
  "generatedAt": "catalog-v1",
  "families": [
    {
      "id": "abril-fatface",
      "family": "Abril Fatface",
      "displayName": "Abril Fatface",
      "variable": false
    },
    {
      "id": "alfa-slab-one",
      "family": "Alfa Slab One",
      "displayName": "Alfa Slab One",
      "variable": false
    },
    {
      "id": "anton",
      "family": "Anton",
      "displayName": "Anton",
      "variable": false
    },
    {
      "id": "archivo-black",
      "family": "Archivo Black",
      "displayName": "Archivo Black",
      "variable": false
    },
    {
      "id": "assistant",
      "family": "Assistant",
      "displayName": "Assistant",
      "variable": true
    },
    {
      "id": "atkinson-hyperlegible",
      "family": "Atkinson Hyperlegible",
      "displayName": "Atkinson Hyperlegible",
      "variable": true
    },
    {
      "id": "baloo-2",
      "family": "Baloo 2",
      "displayName": "Baloo 2",
      "variable": true
    },
    {
      "id": "bangers",
      "family": "Bangers",
      "displayName": "Bangers",
      "variable": false
    },
    {
      "id": "barlow",
      "family": "Barlow",
      "displayName": "Barlow",
      "variable": true
    },
    {
      "id": "bebas-neue",
      "family": "Bebas Neue",
      "displayName": "Bebas Neue",
      "variable": false
    },
    {
      "id": "bitter",
      "family": "Bitter",
      "displayName": "Bitter",
      "variable": true
    },
    {
      "id": "bubblegum-sans",
      "family": "Bubblegum Sans",
      "displayName": "Bubblegum Sans",
      "variable": false
    },
    {
      "id": "cabin",
      "family": "Cabin",
      "displayName": "Cabin",
      "variable": true
    },
    {
      "id": "cardo",
      "family": "Cardo",
      "displayName": "Cardo",
      "variable": false
    },
    {
      "id": "caveat",
      "family": "Caveat",
      "displayName": "Caveat",
      "variable": true
    },
    {
      "id": "chewy",
      "family": "Chewy",
      "displayName": "Chewy",
      "variable": false
    },
    {
      "id": "cinzel",
      "family": "Cinzel",
      "displayName": "Cinzel",
      "variable": false
    },
    {
      "id": "comfortaa",
      "family": "Comfortaa",
      "displayName": "Comfortaa",
      "variable": true
    },
    {
      "id": "concert-one",
      "family": "Concert One",
      "displayName": "Concert One",
      "variable": false
    },
    {
      "id": "cormorant-garamond",
      "family": "Cormorant Garamond",
      "displayName": "Cormorant Garamond",
      "variable": false
    },
    {
      "id": "creepster",
      "family": "Creepster",
      "displayName": "Creepster",
      "variable": false
    },
    {
      "id": "crimson-pro",
      "family": "Crimson Pro",
      "displayName": "Crimson Pro",
      "variable": false
    },
    {
      "id": "dancing-script",
      "family": "Dancing Script",
      "displayName": "Dancing Script",
      "variable": true
    },
    {
      "id": "dm-mono",
      "family": "DM Mono",
      "displayName": "DM Mono",
      "variable": false
    },
    {
      "id": "dm-sans",
      "family": "DM Sans",
      "displayName": "DM Sans",
      "variable": true
    },
    {
      "id": "eb-garamond",
      "family": "EB Garamond",
      "displayName": "EB Garamond",
      "variable": true
    },
    {
      "id": "fira-code",
      "family": "Fira Code",
      "displayName": "Fira Code",
      "variable": true
    },
    {
      "id": "fragment-mono",
      "family": "Fragment Mono",
      "displayName": "Fragment Mono",
      "variable": false
    },
    {
      "id": "fredoka",
      "family": "Fredoka",
      "displayName": "Fredoka",
      "variable": true
    },
    {
      "id": "great-vibes",
      "family": "Great Vibes",
      "displayName": "Great Vibes",
      "variable": false
    },
    {
      "id": "ibm-plex-mono",
      "family": "IBM Plex Mono",
      "displayName": "IBM Plex Mono",
      "variable": false
    },
    {
      "id": "inconsolata",
      "family": "Inconsolata",
      "displayName": "Inconsolata",
      "variable": true
    },
    {
      "id": "indie-flower",
      "family": "Indie Flower",
      "displayName": "Indie Flower",
      "variable": false
    },
    {
      "id": "inter",
      "family": "Inter",
      "displayName": "Inter",
      "variable": true
    },
    {
      "id": "jetbrains-mono",
      "family": "JetBrains Mono",
      "displayName": "JetBrains Mono",
      "variable": true
    },
    {
      "id": "kalam",
      "family": "Kalam",
      "displayName": "Kalam",
      "variable": false
    },
    {
      "id": "karla",
      "family": "Karla",
      "displayName": "Karla",
      "variable": true
    },
    {
      "id": "lato",
      "family": "Lato",
      "displayName": "Lato",
      "variable": false
    },
    {
      "id": "lexend",
      "family": "Lexend",
      "displayName": "Lexend",
      "variable": true
    },
    {
      "id": "libre-baskerville",
      "family": "Libre Baskerville",
      "displayName": "Libre Baskerville",
      "variable": false
    },
    {
      "id": "lilita-one",
      "family": "Lilita One",
      "displayName": "Lilita One",
      "variable": false
    },
    {
      "id": "lobster",
      "family": "Lobster",
      "displayName": "Lobster",
      "variable": false
    },
    {
      "id": "lora",
      "family": "Lora",
      "displayName": "Lora",
      "variable": true
    },
    {
      "id": "luckiest-guy",
      "family": "Luckiest Guy",
      "displayName": "Luckiest Guy",
      "variable": false
    },
    {
      "id": "manrope",
      "family": "Manrope",
      "displayName": "Manrope",
      "variable": true
    },
    {
      "id": "merriweather",
      "family": "Merriweather",
      "displayName": "Merriweather",
      "variable": false
    },
    {
      "id": "montserrat",
      "family": "Montserrat",
      "displayName": "Montserrat",
      "variable": true
    },
    {
      "id": "mulish",
      "family": "Mulish",
      "displayName": "Mulish",
      "variable": true
    },
    {
      "id": "nunito",
      "family": "Nunito",
      "displayName": "Nunito",
      "variable": true
    },
    {
      "id": "nunito-sans",
      "family": "Nunito Sans",
      "displayName": "Nunito Sans",
      "variable": true
    },
    {
      "id": "open-sans",
      "family": "Open Sans",
      "displayName": "Open Sans",
      "variable": true
    },
    {
      "id": "oswald",
      "family": "Oswald",
      "displayName": "Oswald",
      "variable": true
    },
    {
      "id": "outfit",
      "family": "Outfit",
      "displayName": "Outfit",
      "variable": true
    },
    {
      "id": "pacifico",
      "family": "Pacifico",
      "displayName": "Pacifico",
      "variable": false
    },
    {
      "id": "patrick-hand",
      "family": "Patrick Hand",
      "displayName": "Patrick Hand",
      "variable": false
    },
    {
      "id": "patua-one",
      "family": "Patua One",
      "displayName": "Patua One",
      "variable": false
    },
    {
      "id": "permanent-marker",
      "family": "Permanent Marker",
      "displayName": "Permanent Marker",
      "variable": false
    },
    {
      "id": "playfair-display",
      "family": "Playfair Display",
      "displayName": "Playfair Display",
      "variable": true
    },
    {
      "id": "plus-jakarta-sans",
      "family": "Plus Jakarta Sans",
      "displayName": "Plus Jakarta Sans",
      "variable": true
    },
    {
      "id": "poppins",
      "family": "Poppins",
      "displayName": "Poppins",
      "variable": false
    },
    {
      "id": "pt-serif",
      "family": "PT Serif",
      "displayName": "PT Serif",
      "variable": false
    },
    {
      "id": "quicksand",
      "family": "Quicksand",
      "displayName": "Quicksand",
      "variable": true
    },
    {
      "id": "raleway",
      "family": "Raleway",
      "displayName": "Raleway",
      "variable": true
    },
    {
      "id": "righteous",
      "family": "Righteous",
      "displayName": "Righteous",
      "variable": false
    },
    {
      "id": "roboto",
      "family": "Roboto",
      "displayName": "Roboto",
      "variable": true
    },
    {
      "id": "roboto-mono",
      "family": "Roboto Mono",
      "displayName": "Roboto Mono",
      "variable": true
    },
    {
      "id": "rubik",
      "family": "Rubik",
      "displayName": "Rubik",
      "variable": true
    },
    {
      "id": "russo-one",
      "family": "Russo One",
      "displayName": "Russo One",
      "variable": false
    },
    {
      "id": "sacramento",
      "family": "Sacramento",
      "displayName": "Sacramento",
      "variable": false
    },
    {
      "id": "satisfy",
      "family": "Satisfy",
      "displayName": "Satisfy",
      "variable": false
    },
    {
      "id": "shadows-into-light",
      "family": "Shadows Into Light",
      "displayName": "Shadows Into Light",
      "variable": false
    },
    {
      "id": "sora",
      "family": "Sora",
      "displayName": "Sora",
      "variable": true
    },
    {
      "id": "source-code-pro",
      "family": "Source Code Pro",
      "displayName": "Source Code Pro",
      "variable": true
    },
    {
      "id": "source-sans-3",
      "family": "Source Sans 3",
      "displayName": "Source Sans 3",
      "variable": true
    },
    {
      "id": "source-serif-4",
      "family": "Source Serif 4",
      "displayName": "Source Serif 4",
      "variable": true
    },
    {
      "id": "space-grotesk",
      "family": "Space Grotesk",
      "displayName": "Space Grotesk",
      "variable": true
    },
    {
      "id": "space-mono",
      "family": "Space Mono",
      "displayName": "Space Mono",
      "variable": false
    },
    {
      "id": "spectral",
      "family": "Spectral",
      "displayName": "Spectral",
      "variable": true
    },
    {
      "id": "titan-one",
      "family": "Titan One",
      "displayName": "Titan One",
      "variable": false
    },
    {
      "id": "ubuntu-mono",
      "family": "Ubuntu Mono",
      "displayName": "Ubuntu Mono",
      "variable": false
    },
    {
      "id": "work-sans",
      "family": "Work Sans",
      "displayName": "Work Sans",
      "variable": true
    }
  ],
  "files": [
    {
      "id": "804040b2e060e7ed",
      "familyId": "abril-fatface",
      "relPath": "abril-fatface/804040b2e060e7ed.woff2",
      "sha256": "804040b2e060e7ed0a1fbddadf8b1abbdab085b1e66b4523714c7e26839e9ed4",
      "bytes": 13128
    },
    {
      "id": "8835f53d4e16899b",
      "familyId": "alfa-slab-one",
      "relPath": "alfa-slab-one/8835f53d4e16899b.woff2",
      "sha256": "8835f53d4e16899bbe66799b5f9275ca07d897dcf9f4db4131449bde5eee6fbf",
      "bytes": 11580
    },
    {
      "id": "23aab0b2692a0c89",
      "familyId": "anton",
      "relPath": "anton/23aab0b2692a0c89.woff2",
      "sha256": "23aab0b2692a0c89eb7997d3c7cf5bda41276d6cd4ab6cc0edc3edfcece32b09",
      "bytes": 12004
    },
    {
      "id": "4eca2abdbbc1998c",
      "familyId": "archivo-black",
      "relPath": "archivo-black/4eca2abdbbc1998c.woff2",
      "sha256": "4eca2abdbbc1998c3a286e2e83a2256be5263ccb801aa93b00c64fea891efd3a",
      "bytes": 9792
    },
    {
      "id": "93ba70e47226645b",
      "familyId": "assistant",
      "relPath": "assistant/93ba70e47226645b.woff2",
      "sha256": "93ba70e47226645b097e8818580b794d02227d64fad34a0a514fd0ed4362e441",
      "bytes": 22056
    },
    {
      "id": "1cc7c0c5fbf16d1b",
      "familyId": "atkinson-hyperlegible",
      "relPath": "atkinson-hyperlegible/1cc7c0c5fbf16d1b.woff2",
      "sha256": "1cc7c0c5fbf16d1be3cb6d95c89fc0afd0e11f264e239ac97c64a326c5d88fe4",
      "bytes": 11364
    },
    {
      "id": "3987a9380206f1fe",
      "familyId": "atkinson-hyperlegible",
      "relPath": "atkinson-hyperlegible/3987a9380206f1fe.woff2",
      "sha256": "3987a9380206f1fe82996907601efa98b5cda98dd8cd37b94e2688677ecdc28d",
      "bytes": 12284
    },
    {
      "id": "5ee711c886e47940",
      "familyId": "atkinson-hyperlegible",
      "relPath": "atkinson-hyperlegible/5ee711c886e47940.woff2",
      "sha256": "5ee711c886e479406e0ef239f5cc6db7cae99906af00e774950d96189113ed9d",
      "bytes": 12068
    },
    {
      "id": "a60206dd4793eb88",
      "familyId": "atkinson-hyperlegible",
      "relPath": "atkinson-hyperlegible/a60206dd4793eb88.woff2",
      "sha256": "a60206dd4793eb886952e48dc3e1c1d59942c004b2ab1e0086e7ccd156a7852d",
      "bytes": 11208
    },
    {
      "id": "2e9420db49d01d76",
      "familyId": "baloo-2",
      "relPath": "baloo-2/2e9420db49d01d76.woff2",
      "sha256": "2e9420db49d01d76a7b8a38ef22ec9c45305d9f15fafa370389b7bf467658fc3",
      "bytes": 33056
    },
    {
      "id": "d37507cc3862404b",
      "familyId": "bangers",
      "relPath": "bangers/d37507cc3862404b.woff2",
      "sha256": "d37507cc3862404b3f67db10e94e6e2036052a40fc16ab559c7201edf4a77da4",
      "bytes": 17188
    },
    {
      "id": "488b58098126c00b",
      "familyId": "barlow",
      "relPath": "barlow/488b58098126c00b.woff2",
      "sha256": "488b58098126c00b8fa77f4d58b0a4bc982e81e4c83323c1a73d9f1a67c15971",
      "bytes": 15832
    },
    {
      "id": "7a686e76312866b7",
      "familyId": "barlow",
      "relPath": "barlow/7a686e76312866b7.woff2",
      "sha256": "7a686e76312866b7d506c103e51a829d4c96a0b4576835128d3b7b53801c095a",
      "bytes": 15656
    },
    {
      "id": "80e7dc5605dd451b",
      "familyId": "barlow",
      "relPath": "barlow/80e7dc5605dd451b.woff2",
      "sha256": "80e7dc5605dd451bb9b092d7f46704f08bf39d2866cb981aa8caddc016716aed",
      "bytes": 15640
    },
    {
      "id": "98aa8b5c2582107d",
      "familyId": "barlow",
      "relPath": "barlow/98aa8b5c2582107d.woff2",
      "sha256": "98aa8b5c2582107d73a6f1254f08b152b0c037ae5626a902dd44af8c781e0e6d",
      "bytes": 15744
    },
    {
      "id": "af3203d23512ed8c",
      "familyId": "barlow",
      "relPath": "barlow/af3203d23512ed8c.woff2",
      "sha256": "af3203d23512ed8c9e3260a6f9e640247b690db9229d85399a255d2a7ff980ab",
      "bytes": 17512
    },
    {
      "id": "b0c1a6bb98553690",
      "familyId": "barlow",
      "relPath": "barlow/b0c1a6bb98553690.woff2",
      "sha256": "b0c1a6bb98553690544603bb344728e6efee02c5bd04b352e12440591be3e137",
      "bytes": 17588
    },
    {
      "id": "bf0d088f7b5d55a5",
      "familyId": "barlow",
      "relPath": "barlow/bf0d088f7b5d55a5.woff2",
      "sha256": "bf0d088f7b5d55a5340069f586fa1b9cd96ee74eb19a9da71a66803ec1cfb3d4",
      "bytes": 17612
    },
    {
      "id": "fab52d0559785638",
      "familyId": "barlow",
      "relPath": "barlow/fab52d0559785638.woff2",
      "sha256": "fab52d0559785638947742567d71c6bf859d68dcfbbfd39384d8a37e66258f65",
      "bytes": 17408
    },
    {
      "id": "441b026df205d289",
      "familyId": "bebas-neue",
      "relPath": "bebas-neue/441b026df205d289.woff2",
      "sha256": "441b026df205d28954f61b6989c7bbd228c0adff42f746a266c6a5d89134bc34",
      "bytes": 8596
    },
    {
      "id": "261cfc4d27941b27",
      "familyId": "bitter",
      "relPath": "bitter/261cfc4d27941b27.woff2",
      "sha256": "261cfc4d27941b2774efba0a2b03872ddc001dca4423aa3ce278e80301423c1b",
      "bytes": 34156
    },
    {
      "id": "b3254bd6e8f606dd",
      "familyId": "bitter",
      "relPath": "bitter/b3254bd6e8f606dd.woff2",
      "sha256": "b3254bd6e8f606dd900f30fa980dbaa1e9b3df651653e3bda0c6d2fe1806e0d5",
      "bytes": 33376
    },
    {
      "id": "94c7ffae556dab98",
      "familyId": "bubblegum-sans",
      "relPath": "bubblegum-sans/94c7ffae556dab98.woff2",
      "sha256": "94c7ffae556dab989442f37fee5b4c976a8f8290c79aeff194ae9e61ef898d58",
      "bytes": 14136
    },
    {
      "id": "3912b808ba0a5888",
      "familyId": "cabin",
      "relPath": "cabin/3912b808ba0a5888.woff2",
      "sha256": "3912b808ba0a5888e70ec69585dc500bfd241929c58f073ff7789b12179c3843",
      "bytes": 28228
    },
    {
      "id": "d792ce3d8557e7fe",
      "familyId": "cabin",
      "relPath": "cabin/d792ce3d8557e7fe.woff2",
      "sha256": "d792ce3d8557e7fe9f20bac5c1d1ffdbe7567249ad2ffe9a3c5aef285b26c8db",
      "bytes": 29968
    },
    {
      "id": "6985e79e50789588",
      "familyId": "cardo",
      "relPath": "cardo/6985e79e50789588.woff2",
      "sha256": "6985e79e5078958897e276228b9838c3bd5bb7bbaad662cb3f742e87c39e6e4c",
      "bytes": 19220
    },
    {
      "id": "bc802f41dcc8a736",
      "familyId": "cardo",
      "relPath": "cardo/bc802f41dcc8a736.woff2",
      "sha256": "bc802f41dcc8a73610b107af50373231bdc8dee8c0106a46be8efda44ea336b2",
      "bytes": 18956
    },
    {
      "id": "c0a8e24244241209",
      "familyId": "cardo",
      "relPath": "cardo/c0a8e24244241209.woff2",
      "sha256": "c0a8e24244241209f450c50f86a0dfcb5a891806184095b31abdbb136e9b38cc",
      "bytes": 15476
    },
    {
      "id": "7a0049db01fdd8fc",
      "familyId": "caveat",
      "relPath": "caveat/7a0049db01fdd8fc.woff2",
      "sha256": "7a0049db01fdd8fc7af7ef36675862a72a5c76d0cb45ae63c9f5b6f1b769dac7",
      "bytes": 74572
    },
    {
      "id": "cc67b3104c809897",
      "familyId": "chewy",
      "relPath": "chewy/cc67b3104c809897.woff2",
      "sha256": "cc67b3104c8098976c6a9e4275c54864e0628505086b5f01c8f231b9bdd4b0b2",
      "bytes": 17292
    },
    {
      "id": "ef95296c778719c3",
      "familyId": "cinzel",
      "relPath": "cinzel/ef95296c778719c3.woff2",
      "sha256": "ef95296c778719c3d658a8284d65078100450948851b9114485ada01d9d3d3f8",
      "bytes": 25888
    },
    {
      "id": "0742cc2fdcb9a4b3",
      "familyId": "comfortaa",
      "relPath": "comfortaa/0742cc2fdcb9a4b3.woff2",
      "sha256": "0742cc2fdcb9a4b36234c2363dbb60c1dff334a75c371258d3a202806248d64b",
      "bytes": 23028
    },
    {
      "id": "3a79036334707828",
      "familyId": "concert-one",
      "relPath": "concert-one/3a79036334707828.woff2",
      "sha256": "3a79036334707828080084108bf99574f06d1d8d893f840b08a4a4173051132b",
      "bytes": 14380
    },
    {
      "id": "5d618c462b7a5b74",
      "familyId": "cormorant-garamond",
      "relPath": "cormorant-garamond/5d618c462b7a5b74.woff2",
      "sha256": "5d618c462b7a5b74f442e1548880086af71764d9cc7d35c16ab45353da934621",
      "bytes": 37776
    },
    {
      "id": "e6d6d1d73858aa9b",
      "familyId": "cormorant-garamond",
      "relPath": "cormorant-garamond/e6d6d1d73858aa9b.woff2",
      "sha256": "e6d6d1d73858aa9b66f3a3539f9dec22faab2276e61ad1d813bc04dd59c9c122",
      "bytes": 39304
    },
    {
      "id": "6afd8405a83ad535",
      "familyId": "creepster",
      "relPath": "creepster/6afd8405a83ad535.woff2",
      "sha256": "6afd8405a83ad5351f23dd72e18491353acde2caf91b5aac0023942deb6cbe3a",
      "bytes": 28132
    },
    {
      "id": "89374859da8085db",
      "familyId": "crimson-pro",
      "relPath": "crimson-pro/89374859da8085db.woff2",
      "sha256": "89374859da8085dbce486eed120a12abcab5a90e725f8b9c41a3e2b32bd010f6",
      "bytes": 48152
    },
    {
      "id": "f6e346888097c3dd",
      "familyId": "crimson-pro",
      "relPath": "crimson-pro/f6e346888097c3dd.woff2",
      "sha256": "f6e346888097c3dd29a15620fdd1a727af7df5a71d7dc3c2c84f8682bc2cd716",
      "bytes": 51376
    },
    {
      "id": "5e08eb55c88b8658",
      "familyId": "dancing-script",
      "relPath": "dancing-script/5e08eb55c88b8658.woff2",
      "sha256": "5e08eb55c88b8658453e2ba916023964e0f67b98cd7abfa436eb8150968ee19e",
      "bytes": 42604
    },
    {
      "id": "0e263db52797086e",
      "familyId": "dm-mono",
      "relPath": "dm-mono/0e263db52797086e.woff2",
      "sha256": "0e263db52797086e763679c54f84ded8cc1249879bc27dca2bd5dd446f6d9f36",
      "bytes": 8724
    },
    {
      "id": "4e454823a2c67846",
      "familyId": "dm-mono",
      "relPath": "dm-mono/4e454823a2c67846.woff2",
      "sha256": "4e454823a2c678463cdb8647d84a9658b44b9219fc0696b2c37a42669b5ff028",
      "bytes": 9516
    },
    {
      "id": "fd7521f3531a5ccf",
      "familyId": "dm-mono",
      "relPath": "dm-mono/fd7521f3531a5ccf.woff2",
      "sha256": "fd7521f3531a5ccfc655b25c4f22e9871df3ec141ad79bb27fde20d0df347b6d",
      "bytes": 8688
    },
    {
      "id": "fdb2cd7210a5a587",
      "familyId": "dm-mono",
      "relPath": "dm-mono/fdb2cd7210a5a587.woff2",
      "sha256": "fdb2cd7210a5a5879a5b688111d20733a3aace3a9724c4cf3d46617b8ccdca09",
      "bytes": 9556
    },
    {
      "id": "468d56b6b25b05b7",
      "familyId": "dm-sans",
      "relPath": "dm-sans/468d56b6b25b05b7.woff2",
      "sha256": "468d56b6b25b05b70190b6c233d773f6f1770e8579827ce022a57f03fa8002fb",
      "bytes": 36980
    },
    {
      "id": "f3135f3a240c799a",
      "familyId": "dm-sans",
      "relPath": "dm-sans/f3135f3a240c799a.woff2",
      "sha256": "f3135f3a240c799aaf56adaf6f6ca51a1d4157b9301dbaf987760adca9e5d57a",
      "bytes": 39804
    },
    {
      "id": "79d17b52365a2d5b",
      "familyId": "eb-garamond",
      "relPath": "eb-garamond/79d17b52365a2d5b.woff2",
      "sha256": "79d17b52365a2d5bd8995c8c54939d384e9888ed2038c7201fd8d4118d6f0a35",
      "bytes": 41244
    },
    {
      "id": "877ee7495b83e56d",
      "familyId": "eb-garamond",
      "relPath": "eb-garamond/877ee7495b83e56d.woff2",
      "sha256": "877ee7495b83e56d5557cb3dc1d67c1df5172698a0ad743c026aa7ac4e663f3a",
      "bytes": 42476
    },
    {
      "id": "d32d5b5a7c9720cf",
      "familyId": "fira-code",
      "relPath": "fira-code/d32d5b5a7c9720cf.woff2",
      "sha256": "d32d5b5a7c9720cf3812f7d1e3ebdb54116f8f656e7471a03a5a93bdd93c98b3",
      "bytes": 36340
    },
    {
      "id": "4f4dc27f4a770c0d",
      "familyId": "fragment-mono",
      "relPath": "fragment-mono/4f4dc27f4a770c0d.woff2",
      "sha256": "4f4dc27f4a770c0d02fde800daa836c8adc0d1e423b28da74baaf0d1cc3ab96c",
      "bytes": 15176
    },
    {
      "id": "836de8533e207499",
      "familyId": "fragment-mono",
      "relPath": "fragment-mono/836de8533e207499.woff2",
      "sha256": "836de8533e207499ee055cb8fad970be248d47f2ee2f20aee85cd49f783f72bb",
      "bytes": 15944
    },
    {
      "id": "27d49d7c8362279b",
      "familyId": "fredoka",
      "relPath": "fredoka/27d49d7c8362279b.woff2",
      "sha256": "27d49d7c8362279bf81267c615481f4be9548d7568d58889aeb1a6395dd6c070",
      "bytes": 29704
    },
    {
      "id": "0237c8316409c1e4",
      "familyId": "great-vibes",
      "relPath": "great-vibes/0237c8316409c1e4.woff2",
      "sha256": "0237c8316409c1e4c267156adcc6b17a1d5573320efa45b707fe39989ac3874b",
      "bytes": 29596
    },
    {
      "id": "2665f5fbbb334780",
      "familyId": "ibm-plex-mono",
      "relPath": "ibm-plex-mono/2665f5fbbb334780.woff2",
      "sha256": "2665f5fbbb334780fa135c7f1dc6e2459061a2d6d44c32b7c1fdbc34cde65ede",
      "bytes": 11568
    },
    {
      "id": "a76f53ca6612e7b3",
      "familyId": "ibm-plex-mono",
      "relPath": "ibm-plex-mono/a76f53ca6612e7b3.woff2",
      "sha256": "a76f53ca6612e7b3828eec2311098675b7f9849ae4169a8bcef6302aec02a6c0",
      "bytes": 10060
    },
    {
      "id": "c36f509c0a8f9f85",
      "familyId": "ibm-plex-mono",
      "relPath": "ibm-plex-mono/c36f509c0a8f9f85.woff2",
      "sha256": "c36f509c0a8f9f85f29cb44bc8701d8a9e0b14c499e77a884f789ead7093a7ac",
      "bytes": 10052
    },
    {
      "id": "ca01bc88e9b2bfae",
      "familyId": "ibm-plex-mono",
      "relPath": "ibm-plex-mono/ca01bc88e9b2bfae.woff2",
      "sha256": "ca01bc88e9b2bfae3a373baddd098c4be0ef9a5b96f5836361f5b9b409297bea",
      "bytes": 11588
    },
    {
      "id": "9f330ef4aa423d08",
      "familyId": "inconsolata",
      "relPath": "inconsolata/9f330ef4aa423d08.woff2",
      "sha256": "9f330ef4aa423d083046fe006a54f1be21a8e00d05b14ee43d50167b0496db46",
      "bytes": 29020
    },
    {
      "id": "7b7dd13c9e06c487",
      "familyId": "indie-flower",
      "relPath": "indie-flower/7b7dd13c9e06c487.woff2",
      "sha256": "7b7dd13c9e06c4873246b4b2eab52bb98b1a269022b11946b88cc746d61f7403",
      "bytes": 19100
    },
    {
      "id": "7ddd9658a57d7c58",
      "familyId": "inter",
      "relPath": "inter/7ddd9658a57d7c58.woff2",
      "sha256": "7ddd9658a57d7c5811b4f6aa43625433d72c05ac83c46a231ef3dfd88813c8a1",
      "bytes": 51636
    },
    {
      "id": "c940764593d0fe5d",
      "familyId": "inter",
      "relPath": "inter/c940764593d0fe5d.woff2",
      "sha256": "c940764593d0fe5d596be327ca7558855e018039fb78509aa21921fd3644c3e4",
      "bytes": 48432
    },
    {
      "id": "2c32b9b3ee358c11",
      "familyId": "jetbrains-mono",
      "relPath": "jetbrains-mono/2c32b9b3ee358c11.woff2",
      "sha256": "2c32b9b3ee358c119e210f6f5195f9bd34894d78a785ff2e95d60e718e400af4",
      "bytes": 31340
    },
    {
      "id": "e3918da535efc38e",
      "familyId": "jetbrains-mono",
      "relPath": "jetbrains-mono/e3918da535efc38e.woff2",
      "sha256": "e3918da535efc38ebdd4e5d2748de8ecf317e930bb74cd600e8e290ca271fc82",
      "bytes": 33096
    },
    {
      "id": "257f0129d54c60cd",
      "familyId": "kalam",
      "relPath": "kalam/257f0129d54c60cd.woff2",
      "sha256": "257f0129d54c60cda0f8856ad1de05e760a219c9365fb19cd50b0cc8fdb2c9d1",
      "bytes": 14040
    },
    {
      "id": "94709c14e53e9ac9",
      "familyId": "kalam",
      "relPath": "kalam/94709c14e53e9ac9.woff2",
      "sha256": "94709c14e53e9ac948054b9ae9e487d220bd6848f11c558898fd897b0057d721",
      "bytes": 13224
    },
    {
      "id": "c1bc5092263cb16e",
      "familyId": "kalam",
      "relPath": "kalam/c1bc5092263cb16e.woff2",
      "sha256": "c1bc5092263cb16e72fa43621eb116966068950e1b77ffd38fd401dd43ce1120",
      "bytes": 13104
    },
    {
      "id": "690fabf2f17b4a98",
      "familyId": "karla",
      "relPath": "karla/690fabf2f17b4a98.woff2",
      "sha256": "690fabf2f17b4a9833e86103153cc497d3d6c4e8bf2d5fb8ade6a005f5fd731e",
      "bytes": 24264
    },
    {
      "id": "e40d1dec9a7a8ada",
      "familyId": "karla",
      "relPath": "karla/e40d1dec9a7a8ada.woff2",
      "sha256": "e40d1dec9a7a8adacaf0305b3be7c34ab6af75aef35328803f088825265073f4",
      "bytes": 24556
    },
    {
      "id": "4b833d8ce706a334",
      "familyId": "lato",
      "relPath": "lato/4b833d8ce706a334.woff2",
      "sha256": "4b833d8ce706a334bf1349ac9e8a424d2754604bdc412ee1ea0ae75e1379ea92",
      "bytes": 14868
    },
    {
      "id": "557b2ebbaa821105",
      "familyId": "lato",
      "relPath": "lato/557b2ebbaa821105.woff2",
      "sha256": "557b2ebbaa821105e39de764e480f0bc8641993863c8133fdecdfb85bf69fcc7",
      "bytes": 14752
    },
    {
      "id": "5c3360f8439a1a3f",
      "familyId": "lato",
      "relPath": "lato/5c3360f8439a1a3f.woff2",
      "sha256": "5c3360f8439a1a3f48e8b58fcb6f3a3cbaaa76488a1b846acfe1e3b623c0562f",
      "bytes": 14860
    },
    {
      "id": "7a7ce1a34f3e9944",
      "familyId": "lato",
      "relPath": "lato/7a7ce1a34f3e9944.woff2",
      "sha256": "7a7ce1a34f3e9944fe88fc61abbc93b6db383afa2b90815fd7ccea456fbce4e5",
      "bytes": 14168
    },
    {
      "id": "7bb29c58eadc0f0c",
      "familyId": "lato",
      "relPath": "lato/7bb29c58eadc0f0c.woff2",
      "sha256": "7bb29c58eadc0f0c7b704f5fce2490d10cb62efa55797a09c9b8f91b3b54cb34",
      "bytes": 13912
    },
    {
      "id": "d4ae5188a65370ec",
      "familyId": "lato",
      "relPath": "lato/d4ae5188a65370ec.woff2",
      "sha256": "d4ae5188a65370ecfe28f42293bbee8297cfd5712c6aadfdb270d48f2bcd88b0",
      "bytes": 13980
    },
    {
      "id": "1ec8f6ee2750554b",
      "familyId": "lexend",
      "relPath": "lexend/1ec8f6ee2750554b.woff2",
      "sha256": "1ec8f6ee2750554b4bc59ff0b507d316a82a7ba37e0e5bebc41d3bd9b9faad46",
      "bytes": 39692
    },
    {
      "id": "a4a7031f5c5283f8",
      "familyId": "libre-baskerville",
      "relPath": "libre-baskerville/a4a7031f5c5283f8.woff2",
      "sha256": "a4a7031f5c5283f81711e2df162634c7d9ce2a422a7547f2b7a3b424616f6936",
      "bytes": 31336
    },
    {
      "id": "b62b98ef69e6e55b",
      "familyId": "libre-baskerville",
      "relPath": "libre-baskerville/b62b98ef69e6e55b.woff2",
      "sha256": "b62b98ef69e6e55b28b9bcac84513eb1bdd1d312a344b1c76e979219923224a5",
      "bytes": 33852
    },
    {
      "id": "8d6cd0f298738a92",
      "familyId": "lilita-one",
      "relPath": "lilita-one/8d6cd0f298738a92.woff2",
      "sha256": "8d6cd0f298738a92ca9bf6e13f54a9191afd06ce04ea00ebbf24499c017191b7",
      "bytes": 10676
    },
    {
      "id": "91f29167fda1cb92",
      "familyId": "lobster",
      "relPath": "lobster/91f29167fda1cb92.woff2",
      "sha256": "91f29167fda1cb9227c5197c473b9f4b7604d2356f096908c31deb8b1cd10159",
      "bytes": 17068
    },
    {
      "id": "3d536d49566e82a7",
      "familyId": "lora",
      "relPath": "lora/3d536d49566e82a7.woff2",
      "sha256": "3d536d49566e82a7905c8b0096758005f6616029ac08528d1f4789c1100dff6a",
      "bytes": 40648
    },
    {
      "id": "6b102ab35aa1f2b3",
      "familyId": "lora",
      "relPath": "lora/6b102ab35aa1f2b3.woff2",
      "sha256": "6b102ab35aa1f2b315788bb4853434ed1e52137603bf7a3da71a682276748d45",
      "bytes": 37792
    },
    {
      "id": "e463777d6d8013e0",
      "familyId": "luckiest-guy",
      "relPath": "luckiest-guy/e463777d6d8013e0.woff2",
      "sha256": "e463777d6d8013e06e5571ffe7c1c401858600d21d5081288337813fb3b94b2e",
      "bytes": 17112
    },
    {
      "id": "e310b55a7fd9677f",
      "familyId": "manrope",
      "relPath": "manrope/e310b55a7fd9677f.woff2",
      "sha256": "e310b55a7fd9677f5e3555e6c6c4d064fa1f1d24393f0ddbe217cea12a8c432f",
      "bytes": 24576
    },
    {
      "id": "a81373d3b74e7a7b",
      "familyId": "merriweather",
      "relPath": "merriweather/a81373d3b74e7a7b.woff2",
      "sha256": "a81373d3b74e7a7bac2e22eade484e873772519e7e9cd81ee1f717d4408a84ab",
      "bytes": 100620
    },
    {
      "id": "af1be39e2ff60ede",
      "familyId": "merriweather",
      "relPath": "merriweather/af1be39e2ff60ede.woff2",
      "sha256": "af1be39e2ff60ede976bc3a93b9aceb3ac7103207b21a62d1971e3ea8cf95b97",
      "bytes": 97608
    },
    {
      "id": "6438d7b8ea9c7c39",
      "familyId": "montserrat",
      "relPath": "montserrat/6438d7b8ea9c7c39.woff2",
      "sha256": "6438d7b8ea9c7c3992d5e2fd2afdb1ff948570a3ef0bedae76247b51632960ba",
      "bytes": 35508
    },
    {
      "id": "86589d0b59b31171",
      "familyId": "montserrat",
      "relPath": "montserrat/86589d0b59b31171.woff2",
      "sha256": "86589d0b59b311712c3cbaac0b94eb054ecda4be7b52d695588548e4754b3165",
      "bytes": 37120
    },
    {
      "id": "14cc0eabadfeb1af",
      "familyId": "mulish",
      "relPath": "mulish/14cc0eabadfeb1af.woff2",
      "sha256": "14cc0eabadfeb1af90ba3b304aa71074d5f13f2807fa899a1efcbc13c3275cbc",
      "bytes": 29896
    },
    {
      "id": "59b79338a0889d12",
      "familyId": "mulish",
      "relPath": "mulish/59b79338a0889d12.woff2",
      "sha256": "59b79338a0889d12fcad070c4774bbcdd4087f0283cb9b191088d865244f3ae2",
      "bytes": 32472
    },
    {
      "id": "39184f4d011106f5",
      "familyId": "nunito-sans",
      "relPath": "nunito-sans/39184f4d011106f5.woff2",
      "sha256": "39184f4d011106f5bfbe3813d3a8c3673663f04a45a9c9f55b1ed15f4d5b1cc9",
      "bytes": 30948
    },
    {
      "id": "bd5645075f472696",
      "familyId": "nunito-sans",
      "relPath": "nunito-sans/bd5645075f472696.woff2",
      "sha256": "bd5645075f4726964b723cf66fabe0087fb785ee5d6b002beba89e7a802c4646",
      "bytes": 32924
    },
    {
      "id": "20fc9b6fc618e7c3",
      "familyId": "nunito",
      "relPath": "nunito/20fc9b6fc618e7c3.woff2",
      "sha256": "20fc9b6fc618e7c3c68d3ac750a2a5dfbceb8521675458d2cea580b5693e4798",
      "bytes": 39152
    },
    {
      "id": "60ad29f2b640800b",
      "familyId": "nunito",
      "relPath": "nunito/60ad29f2b640800b.woff2",
      "sha256": "60ad29f2b640800bcd6a5bf81b4583a41de31b8f5153f31e5c9894430e749a8a",
      "bytes": 41744
    },
    {
      "id": "441af0def989ebfd",
      "familyId": "open-sans",
      "relPath": "open-sans/441af0def989ebfd.woff2",
      "sha256": "441af0def989ebfdbd6ad85ffaed85e967ab21a05f1dd342f16259464a206dd0",
      "bytes": 42964
    },
    {
      "id": "8df90accd45bfd23",
      "familyId": "open-sans",
      "relPath": "open-sans/8df90accd45bfd23.woff2",
      "sha256": "8df90accd45bfd23e80b325300058648f6d4b293d1c8f399dfa4cda318d203e0",
      "bytes": 45072
    },
    {
      "id": "9dde3797547520f7",
      "familyId": "oswald",
      "relPath": "oswald/9dde3797547520f7.woff2",
      "sha256": "9dde3797547520f762f4ba3a822d417a0872b962bc78753a7ee9f955382b6b85",
      "bytes": 21412
    },
    {
      "id": "92684e4acde79ef0",
      "familyId": "outfit",
      "relPath": "outfit/92684e4acde79ef0.woff2",
      "sha256": "92684e4acde79ef07758cd09380b7e01e9824d8b061eddeda046f78c166d7b12",
      "bytes": 32228
    },
    {
      "id": "1a47a54e53bbfd3c",
      "familyId": "pacifico",
      "relPath": "pacifico/1a47a54e53bbfd3c.woff2",
      "sha256": "1a47a54e53bbfd3cfb4673636eac5edc98a7ecbf36c41340f48086a4f4796b18",
      "bytes": 22296
    },
    {
      "id": "42156e008dd5fc30",
      "familyId": "patrick-hand",
      "relPath": "patrick-hand/42156e008dd5fc30.woff2",
      "sha256": "42156e008dd5fc3000679ff4e9ba9cbd3f417b6317c6dcbe11a12e9c87a09b28",
      "bytes": 14224
    },
    {
      "id": "1d8f4646c42ec4ed",
      "familyId": "patua-one",
      "relPath": "patua-one/1d8f4646c42ec4ed.woff2",
      "sha256": "1d8f4646c42ec4edbc72dab935d5a4728908eed4f4ac4908fdc1e73adc6cf6c0",
      "bytes": 12928
    },
    {
      "id": "37202f2915830dbf",
      "familyId": "permanent-marker",
      "relPath": "permanent-marker/37202f2915830dbf.woff2",
      "sha256": "37202f2915830dbf5ca57d32ee0a2a9e8dc876e92720214ddef1e0c4bfe8bb98",
      "bytes": 29296
    },
    {
      "id": "5d91eb5d522a0308",
      "familyId": "playfair-display",
      "relPath": "playfair-display/5d91eb5d522a0308.woff2",
      "sha256": "5d91eb5d522a03081946c44c8ca17c902230dfed5f0f9b5014262135d47b15b2",
      "bytes": 38460
    },
    {
      "id": "c68530044e7c4ce6",
      "familyId": "playfair-display",
      "relPath": "playfair-display/c68530044e7c4ce6.woff2",
      "sha256": "c68530044e7c4ce6cd3c1c239d0a93be71af53821574714f83e1380d8b393d14",
      "bytes": 38888
    },
    {
      "id": "cd8db90cd950e26b",
      "familyId": "plus-jakarta-sans",
      "relPath": "plus-jakarta-sans/cd8db90cd950e26b.woff2",
      "sha256": "cd8db90cd950e26bc8761f65d323588bd5cd112d326d6d322bc7c8ea86771215",
      "bytes": 27272
    },
    {
      "id": "f7f3c763fa674935",
      "familyId": "plus-jakarta-sans",
      "relPath": "plus-jakarta-sans/f7f3c763fa674935.woff2",
      "sha256": "f7f3c763fa6749357a187418d736aab5b2acdd1d0a83a408631382bcfd80d141",
      "bytes": 29524
    },
    {
      "id": "197a3cbd7290c242",
      "familyId": "poppins",
      "relPath": "poppins/197a3cbd7290c242.woff2",
      "sha256": "197a3cbd7290c242c5c765268cdd69a9a39867fdc80cd13071f243a81c56fb76",
      "bytes": 7848
    },
    {
      "id": "289e0afc8be731a8",
      "familyId": "poppins",
      "relPath": "poppins/289e0afc8be731a8.woff2",
      "sha256": "289e0afc8be731a86822349e54557296f145926496bd2138db1bac0db77f77a2",
      "bytes": 7740
    },
    {
      "id": "3dc5d0c52428fe16",
      "familyId": "poppins",
      "relPath": "poppins/3dc5d0c52428fe16.woff2",
      "sha256": "3dc5d0c52428fe1696264907a1054ebbaac07f8cbe45832c105f819c2ae397c0",
      "bytes": 7900
    },
    {
      "id": "4eaac5c96bd47f9f",
      "familyId": "poppins",
      "relPath": "poppins/4eaac5c96bd47f9f.woff2",
      "sha256": "4eaac5c96bd47f9fd1f09c91f0b27b5a93346ed7e94de849c835f2116cea3e1d",
      "bytes": 8676
    },
    {
      "id": "54c799453c6f2cc8",
      "familyId": "poppins",
      "relPath": "poppins/54c799453c6f2cc8.woff2",
      "sha256": "54c799453c6f2cc895ca6b433513a87b131ad842d744bd298b1b13a7d1b86705",
      "bytes": 8628
    },
    {
      "id": "872e862918591a9e",
      "familyId": "poppins",
      "relPath": "poppins/872e862918591a9e.woff2",
      "sha256": "872e862918591a9e824dc03ed92f05729435ffbb8ebbb10eff7eda26592b1798",
      "bytes": 7992
    },
    {
      "id": "b9e0b57083ed1749",
      "familyId": "poppins",
      "relPath": "poppins/b9e0b57083ed1749.woff2",
      "sha256": "b9e0b57083ed17492a747b61d572c88f5bd7a0cb2ad0febf847014d751fba428",
      "bytes": 8740
    },
    {
      "id": "dace3f9d671eae07",
      "familyId": "poppins",
      "relPath": "poppins/dace3f9d671eae07.woff2",
      "sha256": "dace3f9d671eae070fb2aa8d4c08a9bb6838a72f3b89701310855700e492aadc",
      "bytes": 8516
    },
    {
      "id": "202b8aa6108ec44b",
      "familyId": "pt-serif",
      "relPath": "pt-serif/202b8aa6108ec44b.woff2",
      "sha256": "202b8aa6108ec44ba8f3d717b0c9f7f94c7f4d76f01943104eaadaf6cf3da602",
      "bytes": 13400
    },
    {
      "id": "219a8e6238f7f0b4",
      "familyId": "pt-serif",
      "relPath": "pt-serif/219a8e6238f7f0b4.woff2",
      "sha256": "219a8e6238f7f0b4bbd73b68ee78d0211d44c7808510fa5b9da6a1621bf63e6d",
      "bytes": 14236
    },
    {
      "id": "57d3ae6c4b78cc2d",
      "familyId": "pt-serif",
      "relPath": "pt-serif/57d3ae6c4b78cc2d.woff2",
      "sha256": "57d3ae6c4b78cc2d5b568212e1fcd75e5a0be45e6249e55750ba77d22e22bc3b",
      "bytes": 13540
    },
    {
      "id": "c4ccc041f7601de4",
      "familyId": "pt-serif",
      "relPath": "pt-serif/c4ccc041f7601de4.woff2",
      "sha256": "c4ccc041f7601de446b71e38de328ff979696476f9e10d20e5df8d511691ceae",
      "bytes": 14152
    },
    {
      "id": "1b092c711df1c7ad",
      "familyId": "quicksand",
      "relPath": "quicksand/1b092c711df1c7ad.woff2",
      "sha256": "1b092c711df1c7ad200c2bc73305c792315ff882adbac925d79fb432bc0673c3",
      "bytes": 28336
    },
    {
      "id": "10f1a0ef3f349790",
      "familyId": "raleway",
      "relPath": "raleway/10f1a0ef3f349790.woff2",
      "sha256": "10f1a0ef3f3497901c1c3e9987d0cb97d092a6ce1ff45669a1aed503cf67e6ef",
      "bytes": 43120
    },
    {
      "id": "aadf99b189915dd8",
      "familyId": "raleway",
      "relPath": "raleway/aadf99b189915dd8.woff2",
      "sha256": "aadf99b189915dd80cee82b206bfd492fd98371ba7cf11465e02031aedc8125c",
      "bytes": 45260
    },
    {
      "id": "17bb3e21ead29ad2",
      "familyId": "righteous",
      "relPath": "righteous/17bb3e21ead29ad2.woff2",
      "sha256": "17bb3e21ead29ad20cb4e9ffbfa6eac5dbed184836ae13e5c14cbd6e85ddcce6",
      "bytes": 12136
    },
    {
      "id": "2ed6ac9efae6d21f",
      "familyId": "roboto-mono",
      "relPath": "roboto-mono/2ed6ac9efae6d21f.woff2",
      "sha256": "2ed6ac9efae6d21f51b2946176a0eef79a4043d643f9ac976e66d7fc4d57803a",
      "bytes": 32752
    },
    {
      "id": "52cf6d1b27b1fd0e",
      "familyId": "roboto-mono",
      "relPath": "roboto-mono/52cf6d1b27b1fd0e.woff2",
      "sha256": "52cf6d1b27b1fd0ee92ac6fb753f046fcb0a7e9bf60b1c477744db09e2c48fc9",
      "bytes": 35240
    },
    {
      "id": "0a44e0bb6ba5c853",
      "familyId": "roboto",
      "relPath": "roboto/0a44e0bb6ba5c853.woff2",
      "sha256": "0a44e0bb6ba5c8537e8814c148ef7755f1bce12112361231f595ecc584a18d7a",
      "bytes": 37520
    },
    {
      "id": "9f06741ff731c455",
      "familyId": "roboto",
      "relPath": "roboto/9f06741ff731c455.woff2",
      "sha256": "9f06741ff731c4555398df16ce523ee8fd24dfd9dfd2ff2a6c9d63239cf0e9f7",
      "bytes": 41748
    },
    {
      "id": "664ffdbebe50f73b",
      "familyId": "rubik",
      "relPath": "rubik/664ffdbebe50f73b.woff2",
      "sha256": "664ffdbebe50f73baf579cda033a133d81a13617a45f13cb74f27e60f5d0bdfc",
      "bytes": 36440
    },
    {
      "id": "99ec7ccb40cf143f",
      "familyId": "rubik",
      "relPath": "rubik/99ec7ccb40cf143f.woff2",
      "sha256": "99ec7ccb40cf143f977c893649deece6cc2dcc7c0ff82ebf84b6584090f207ea",
      "bytes": 35324
    },
    {
      "id": "53c9adb058b01d01",
      "familyId": "russo-one",
      "relPath": "russo-one/53c9adb058b01d01.woff2",
      "sha256": "53c9adb058b01d0143a6f23ada52a6719800bf0253edb1439285010eaaca5284",
      "bytes": 7360
    },
    {
      "id": "7b80b397783c2b2b",
      "familyId": "sacramento",
      "relPath": "sacramento/7b80b397783c2b2b.woff2",
      "sha256": "7b80b397783c2b2bcfc27b1ab176d860ff51f23df4ad5f479a575fba3d7c6977",
      "bytes": 23408
    },
    {
      "id": "a690e9f39fdd13e0",
      "familyId": "satisfy",
      "relPath": "satisfy/a690e9f39fdd13e0.woff2",
      "sha256": "a690e9f39fdd13e0aecee046d1682f32ea0f15aa4f3d8c02df809fe0550af3e0",
      "bytes": 22436
    },
    {
      "id": "61cb1fd4967e283a",
      "familyId": "shadows-into-light",
      "relPath": "shadows-into-light/61cb1fd4967e283a.woff2",
      "sha256": "61cb1fd4967e283a8934136558ba07abbc2e228a52a5904de18d1c37529b0b69",
      "bytes": 15988
    },
    {
      "id": "3902474d3ece89c8",
      "familyId": "sora",
      "relPath": "sora/3902474d3ece89c8.woff2",
      "sha256": "3902474d3ece89c8580d5ef3325cf58753e6e45a86f9957b4dacc4fce2e7fde1",
      "bytes": 25240
    },
    {
      "id": "2c935ccea0efa74f",
      "familyId": "source-code-pro",
      "relPath": "source-code-pro/2c935ccea0efa74f.woff2",
      "sha256": "2c935ccea0efa74f1d034628790a2aebfe2ccb6f5d60e8f5b224366066e10188",
      "bytes": 21968
    },
    {
      "id": "68b55e7814164bdc",
      "familyId": "source-code-pro",
      "relPath": "source-code-pro/68b55e7814164bdc.woff2",
      "sha256": "68b55e7814164bdc142e6eea21152d9c682d13b35a537bdba13dc3bc2a2c422f",
      "bytes": 22452
    },
    {
      "id": "ac057a5593cbe3df",
      "familyId": "source-sans-3",
      "relPath": "source-sans-3/ac057a5593cbe3df.woff2",
      "sha256": "ac057a5593cbe3df0d2585da5dd5f33b8efa84aa30550c710fe061b37fc5c54b",
      "bytes": 28792
    },
    {
      "id": "dba77455b9c18867",
      "familyId": "source-sans-3",
      "relPath": "source-sans-3/dba77455b9c18867.woff2",
      "sha256": "dba77455b9c188678eb9103c4b6b7fb8105968c3a4b5828204c350f6781c1638",
      "bytes": 28464
    },
    {
      "id": "286e05e5e444f44e",
      "familyId": "source-serif-4",
      "relPath": "source-serif-4/286e05e5e444f44e.woff2",
      "sha256": "286e05e5e444f44e50724df445808458dea58507e9805bba012b3b12d08ca122",
      "bytes": 50924
    },
    {
      "id": "ad17ab41cc010420",
      "familyId": "source-serif-4",
      "relPath": "source-serif-4/ad17ab41cc010420.woff2",
      "sha256": "ad17ab41cc010420d6a8886d8b8b4a2fc58550c68fee51e54d59f1c7b255a4e4",
      "bytes": 51532
    },
    {
      "id": "a0d054c4af557de2",
      "familyId": "space-grotesk",
      "relPath": "space-grotesk/a0d054c4af557de2.woff2",
      "sha256": "a0d054c4af557de20afd6ca59f47ab353bcaec49c63ff04b6c9d39d0f8910557",
      "bytes": 22320
    },
    {
      "id": "7b001804bf97cfe4",
      "familyId": "space-mono",
      "relPath": "space-mono/7b001804bf97cfe4.woff2",
      "sha256": "7b001804bf97cfe4488183f1713fcb0f5312dd127526e423a8acd1a303c7dd12",
      "bytes": 10660
    },
    {
      "id": "af7cf6d2b897ec45",
      "familyId": "space-mono",
      "relPath": "space-mono/af7cf6d2b897ec45.woff2",
      "sha256": "af7cf6d2b897ec453acdcdacde4e9bcc8410718af5914de865b453e09f10eebc",
      "bytes": 9552
    },
    {
      "id": "bb03cb70d44305b6",
      "familyId": "space-mono",
      "relPath": "space-mono/bb03cb70d44305b6.woff2",
      "sha256": "bb03cb70d44305b604e4d814b4071a8239af4f9542fbbbb67113c5df329560f7",
      "bytes": 10500
    },
    {
      "id": "e0c8e616bda27642",
      "familyId": "space-mono",
      "relPath": "space-mono/e0c8e616bda27642.woff2",
      "sha256": "e0c8e616bda27642f4c3cebaecff6525d901e73afc8a227cbbb0f2af4810f300",
      "bytes": 9464
    },
    {
      "id": "1125ec621f11c866",
      "familyId": "spectral",
      "relPath": "spectral/1125ec621f11c866.woff2",
      "sha256": "1125ec621f11c8669efc3a86cc05d9e9e221853d2b1c9658d9e30de9d3b90bba",
      "bytes": 15180
    },
    {
      "id": "1fb6ca29fc243e8b",
      "familyId": "spectral",
      "relPath": "spectral/1fb6ca29fc243e8b.woff2",
      "sha256": "1fb6ca29fc243e8bfdfce12d8d6806f322bcc62d38036986812be28fb1f41f0a",
      "bytes": 15164
    },
    {
      "id": "1fdd59a028cceea6",
      "familyId": "spectral",
      "relPath": "spectral/1fdd59a028cceea6.woff2",
      "sha256": "1fdd59a028cceea6bbcab1e10f2ccd3d92e6558319dd84180072354cbac3e035",
      "bytes": 16004
    },
    {
      "id": "79ce505722da87b9",
      "familyId": "spectral",
      "relPath": "spectral/79ce505722da87b9.woff2",
      "sha256": "79ce505722da87b9a2fa21a16cd0d7f426f1624fd16413e11be377bc9e922a3b",
      "bytes": 15084
    },
    {
      "id": "7cfafd3583aecfe2",
      "familyId": "spectral",
      "relPath": "spectral/7cfafd3583aecfe2.woff2",
      "sha256": "7cfafd3583aecfe216f860d7a1c5689e86f7f92681946ca582d042c1c96b37d7",
      "bytes": 14988
    },
    {
      "id": "8d4f3594c930ffab",
      "familyId": "spectral",
      "relPath": "spectral/8d4f3594c930ffab.woff2",
      "sha256": "8d4f3594c930ffab6e0c23eb400af6ac1cee5c4e8934cb6a087cbd351b42cbbc",
      "bytes": 16272
    },
    {
      "id": "a0533b33ddd6bedf",
      "familyId": "spectral",
      "relPath": "spectral/a0533b33ddd6bedf.woff2",
      "sha256": "a0533b33ddd6bedf5dd9fc6762b44cc536cff6f408a115146f5f003c2c7edd96",
      "bytes": 16212
    },
    {
      "id": "bcb83e9c56d40c51",
      "familyId": "spectral",
      "relPath": "spectral/bcb83e9c56d40c51.woff2",
      "sha256": "bcb83e9c56d40c5111a2bdbc3d8bdabf66bd31337e968f1c223b61879b8d3cad",
      "bytes": 14028
    },
    {
      "id": "f5f3f60e9246f7e7",
      "familyId": "titan-one",
      "relPath": "titan-one/f5f3f60e9246f7e7.woff2",
      "sha256": "f5f3f60e9246f7e78242697ef18f1fa78467dc4135312208b693e33678e78c4c",
      "bytes": 10732
    },
    {
      "id": "646f2d4b83b5ea2c",
      "familyId": "ubuntu-mono",
      "relPath": "ubuntu-mono/646f2d4b83b5ea2c.woff2",
      "sha256": "646f2d4b83b5ea2ce0351e202377ebbd0734c7c7014cf8735a23d2bf6dd3b924",
      "bytes": 11928
    },
    {
      "id": "6630a8d5ec2bf8da",
      "familyId": "ubuntu-mono",
      "relPath": "ubuntu-mono/6630a8d5ec2bf8da.woff2",
      "sha256": "6630a8d5ec2bf8dab8f7bb3504fbd5467374bf2f923397c2b70727a4ccf0ff12",
      "bytes": 12540
    },
    {
      "id": "83a138fc2854ace0",
      "familyId": "ubuntu-mono",
      "relPath": "ubuntu-mono/83a138fc2854ace0.woff2",
      "sha256": "83a138fc2854ace0a33741372428c3772f801c06faf2c2f0457dcb525c128821",
      "bytes": 12400
    },
    {
      "id": "d908c86a05dde68b",
      "familyId": "ubuntu-mono",
      "relPath": "ubuntu-mono/d908c86a05dde68b.woff2",
      "sha256": "d908c86a05dde68be1ab9298261475b499171e62b5f4094f57744e80bd9af5ba",
      "bytes": 11804
    },
    {
      "id": "72cd8f67849cc714",
      "familyId": "work-sans",
      "relPath": "work-sans/72cd8f67849cc714.woff2",
      "sha256": "72cd8f67849cc714f3364eeeb378df9a49f4aff00e6a3640fad36c9c93a9b197",
      "bytes": 50524
    },
    {
      "id": "b87f48add7ec3052",
      "familyId": "work-sans",
      "relPath": "work-sans/b87f48add7ec3052.woff2",
      "sha256": "b87f48add7ec30528eec5bb08a62bedff58ec6093097d817d3def0c54691ad45",
      "bytes": 48264
    }
  ],
  "faces": [
    {
      "familyId": "abril-fatface",
      "weight": 400,
      "style": "normal",
      "fileId": "804040b2e060e7ed",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "alfa-slab-one",
      "weight": 400,
      "style": "normal",
      "fileId": "8835f53d4e16899b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "anton",
      "weight": 400,
      "style": "normal",
      "fileId": "23aab0b2692a0c89",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "archivo-black",
      "weight": 400,
      "style": "normal",
      "fileId": "4eca2abdbbc1998c",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "assistant",
      "weight": 400,
      "style": "normal",
      "fileId": "93ba70e47226645b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "assistant",
      "weight": 500,
      "style": "normal",
      "fileId": "93ba70e47226645b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "assistant",
      "weight": 600,
      "style": "normal",
      "fileId": "93ba70e47226645b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "assistant",
      "weight": 700,
      "style": "normal",
      "fileId": "93ba70e47226645b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "atkinson-hyperlegible",
      "weight": 400,
      "style": "italic",
      "fileId": "5ee711c886e47940",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "atkinson-hyperlegible",
      "weight": 700,
      "style": "italic",
      "fileId": "3987a9380206f1fe",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "atkinson-hyperlegible",
      "weight": 400,
      "style": "normal",
      "fileId": "a60206dd4793eb88",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "atkinson-hyperlegible",
      "weight": 700,
      "style": "normal",
      "fileId": "1cc7c0c5fbf16d1b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "baloo-2",
      "weight": 400,
      "style": "normal",
      "fileId": "2e9420db49d01d76",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "baloo-2",
      "weight": 500,
      "style": "normal",
      "fileId": "2e9420db49d01d76",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "baloo-2",
      "weight": 600,
      "style": "normal",
      "fileId": "2e9420db49d01d76",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "baloo-2",
      "weight": 700,
      "style": "normal",
      "fileId": "2e9420db49d01d76",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "baloo-2",
      "weight": 800,
      "style": "normal",
      "fileId": "2e9420db49d01d76",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bangers",
      "weight": 400,
      "style": "normal",
      "fileId": "d37507cc3862404b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "barlow",
      "weight": 400,
      "style": "italic",
      "fileId": "b0c1a6bb98553690",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "barlow",
      "weight": 500,
      "style": "italic",
      "fileId": "bf0d088f7b5d55a5",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "barlow",
      "weight": 600,
      "style": "italic",
      "fileId": "af3203d23512ed8c",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "barlow",
      "weight": 700,
      "style": "italic",
      "fileId": "fab52d0559785638",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "barlow",
      "weight": 400,
      "style": "normal",
      "fileId": "7a686e76312866b7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "barlow",
      "weight": 500,
      "style": "normal",
      "fileId": "80e7dc5605dd451b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "barlow",
      "weight": 600,
      "style": "normal",
      "fileId": "488b58098126c00b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "barlow",
      "weight": 700,
      "style": "normal",
      "fileId": "98aa8b5c2582107d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bebas-neue",
      "weight": 400,
      "style": "normal",
      "fileId": "441b026df205d289",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bitter",
      "weight": 400,
      "style": "italic",
      "fileId": "b3254bd6e8f606dd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bitter",
      "weight": 500,
      "style": "italic",
      "fileId": "b3254bd6e8f606dd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bitter",
      "weight": 600,
      "style": "italic",
      "fileId": "b3254bd6e8f606dd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bitter",
      "weight": 700,
      "style": "italic",
      "fileId": "b3254bd6e8f606dd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bitter",
      "weight": 400,
      "style": "normal",
      "fileId": "261cfc4d27941b27",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bitter",
      "weight": 500,
      "style": "normal",
      "fileId": "261cfc4d27941b27",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bitter",
      "weight": 600,
      "style": "normal",
      "fileId": "261cfc4d27941b27",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bitter",
      "weight": 700,
      "style": "normal",
      "fileId": "261cfc4d27941b27",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "bubblegum-sans",
      "weight": 400,
      "style": "normal",
      "fileId": "94c7ffae556dab98",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cabin",
      "weight": 400,
      "style": "italic",
      "fileId": "d792ce3d8557e7fe",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cabin",
      "weight": 500,
      "style": "italic",
      "fileId": "d792ce3d8557e7fe",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cabin",
      "weight": 600,
      "style": "italic",
      "fileId": "d792ce3d8557e7fe",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cabin",
      "weight": 400,
      "style": "normal",
      "fileId": "3912b808ba0a5888",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cabin",
      "weight": 500,
      "style": "normal",
      "fileId": "3912b808ba0a5888",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cabin",
      "weight": 600,
      "style": "normal",
      "fileId": "3912b808ba0a5888",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cardo",
      "weight": 400,
      "style": "italic",
      "fileId": "bc802f41dcc8a736",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cardo",
      "weight": 400,
      "style": "normal",
      "fileId": "c0a8e24244241209",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cardo",
      "weight": 700,
      "style": "normal",
      "fileId": "6985e79e50789588",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "caveat",
      "weight": 400,
      "style": "normal",
      "fileId": "7a0049db01fdd8fc",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "caveat",
      "weight": 500,
      "style": "normal",
      "fileId": "7a0049db01fdd8fc",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "caveat",
      "weight": 600,
      "style": "normal",
      "fileId": "7a0049db01fdd8fc",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "caveat",
      "weight": 700,
      "style": "normal",
      "fileId": "7a0049db01fdd8fc",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "chewy",
      "weight": 400,
      "style": "normal",
      "fileId": "cc67b3104c809897",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cinzel",
      "weight": 400,
      "style": "normal",
      "fileId": "ef95296c778719c3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cinzel",
      "weight": 600,
      "style": "normal",
      "fileId": "ef95296c778719c3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cinzel",
      "weight": 700,
      "style": "normal",
      "fileId": "ef95296c778719c3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "comfortaa",
      "weight": 400,
      "style": "normal",
      "fileId": "0742cc2fdcb9a4b3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "comfortaa",
      "weight": 500,
      "style": "normal",
      "fileId": "0742cc2fdcb9a4b3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "comfortaa",
      "weight": 600,
      "style": "normal",
      "fileId": "0742cc2fdcb9a4b3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "comfortaa",
      "weight": 700,
      "style": "normal",
      "fileId": "0742cc2fdcb9a4b3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "concert-one",
      "weight": 400,
      "style": "normal",
      "fileId": "3a79036334707828",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cormorant-garamond",
      "weight": 400,
      "style": "italic",
      "fileId": "e6d6d1d73858aa9b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cormorant-garamond",
      "weight": 500,
      "style": "italic",
      "fileId": "e6d6d1d73858aa9b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cormorant-garamond",
      "weight": 600,
      "style": "italic",
      "fileId": "e6d6d1d73858aa9b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cormorant-garamond",
      "weight": 400,
      "style": "normal",
      "fileId": "5d618c462b7a5b74",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cormorant-garamond",
      "weight": 500,
      "style": "normal",
      "fileId": "5d618c462b7a5b74",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "cormorant-garamond",
      "weight": 600,
      "style": "normal",
      "fileId": "5d618c462b7a5b74",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "creepster",
      "weight": 400,
      "style": "normal",
      "fileId": "6afd8405a83ad535",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "crimson-pro",
      "weight": 400,
      "style": "italic",
      "fileId": "f6e346888097c3dd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "crimson-pro",
      "weight": 600,
      "style": "italic",
      "fileId": "f6e346888097c3dd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "crimson-pro",
      "weight": 700,
      "style": "italic",
      "fileId": "f6e346888097c3dd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "crimson-pro",
      "weight": 400,
      "style": "normal",
      "fileId": "89374859da8085db",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "crimson-pro",
      "weight": 600,
      "style": "normal",
      "fileId": "89374859da8085db",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "crimson-pro",
      "weight": 700,
      "style": "normal",
      "fileId": "89374859da8085db",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dancing-script",
      "weight": 400,
      "style": "normal",
      "fileId": "5e08eb55c88b8658",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dancing-script",
      "weight": 500,
      "style": "normal",
      "fileId": "5e08eb55c88b8658",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dancing-script",
      "weight": 600,
      "style": "normal",
      "fileId": "5e08eb55c88b8658",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dancing-script",
      "weight": 700,
      "style": "normal",
      "fileId": "5e08eb55c88b8658",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-mono",
      "weight": 400,
      "style": "italic",
      "fileId": "4e454823a2c67846",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-mono",
      "weight": 500,
      "style": "italic",
      "fileId": "fdb2cd7210a5a587",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-mono",
      "weight": 400,
      "style": "normal",
      "fileId": "fd7521f3531a5ccf",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-mono",
      "weight": 500,
      "style": "normal",
      "fileId": "0e263db52797086e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-sans",
      "weight": 400,
      "style": "italic",
      "fileId": "f3135f3a240c799a",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-sans",
      "weight": 500,
      "style": "italic",
      "fileId": "f3135f3a240c799a",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-sans",
      "weight": 600,
      "style": "italic",
      "fileId": "f3135f3a240c799a",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-sans",
      "weight": 700,
      "style": "italic",
      "fileId": "f3135f3a240c799a",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-sans",
      "weight": 400,
      "style": "normal",
      "fileId": "468d56b6b25b05b7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-sans",
      "weight": 500,
      "style": "normal",
      "fileId": "468d56b6b25b05b7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-sans",
      "weight": 600,
      "style": "normal",
      "fileId": "468d56b6b25b05b7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "dm-sans",
      "weight": 700,
      "style": "normal",
      "fileId": "468d56b6b25b05b7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "eb-garamond",
      "weight": 400,
      "style": "italic",
      "fileId": "877ee7495b83e56d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "eb-garamond",
      "weight": 500,
      "style": "italic",
      "fileId": "877ee7495b83e56d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "eb-garamond",
      "weight": 600,
      "style": "italic",
      "fileId": "877ee7495b83e56d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "eb-garamond",
      "weight": 700,
      "style": "italic",
      "fileId": "877ee7495b83e56d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "eb-garamond",
      "weight": 400,
      "style": "normal",
      "fileId": "79d17b52365a2d5b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "eb-garamond",
      "weight": 500,
      "style": "normal",
      "fileId": "79d17b52365a2d5b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "eb-garamond",
      "weight": 600,
      "style": "normal",
      "fileId": "79d17b52365a2d5b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "eb-garamond",
      "weight": 700,
      "style": "normal",
      "fileId": "79d17b52365a2d5b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "fira-code",
      "weight": 400,
      "style": "normal",
      "fileId": "d32d5b5a7c9720cf",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "fira-code",
      "weight": 500,
      "style": "normal",
      "fileId": "d32d5b5a7c9720cf",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "fragment-mono",
      "weight": 400,
      "style": "italic",
      "fileId": "836de8533e207499",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "fragment-mono",
      "weight": 400,
      "style": "normal",
      "fileId": "4f4dc27f4a770c0d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "fredoka",
      "weight": 400,
      "style": "normal",
      "fileId": "27d49d7c8362279b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "fredoka",
      "weight": 500,
      "style": "normal",
      "fileId": "27d49d7c8362279b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "fredoka",
      "weight": 600,
      "style": "normal",
      "fileId": "27d49d7c8362279b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "fredoka",
      "weight": 700,
      "style": "normal",
      "fileId": "27d49d7c8362279b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "great-vibes",
      "weight": 400,
      "style": "normal",
      "fileId": "0237c8316409c1e4",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "ibm-plex-mono",
      "weight": 400,
      "style": "italic",
      "fileId": "2665f5fbbb334780",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "ibm-plex-mono",
      "weight": 500,
      "style": "italic",
      "fileId": "ca01bc88e9b2bfae",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "ibm-plex-mono",
      "weight": 400,
      "style": "normal",
      "fileId": "c36f509c0a8f9f85",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "ibm-plex-mono",
      "weight": 500,
      "style": "normal",
      "fileId": "a76f53ca6612e7b3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "inconsolata",
      "weight": 400,
      "style": "normal",
      "fileId": "9f330ef4aa423d08",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "inconsolata",
      "weight": 500,
      "style": "normal",
      "fileId": "9f330ef4aa423d08",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "indie-flower",
      "weight": 400,
      "style": "normal",
      "fileId": "7b7dd13c9e06c487",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "inter",
      "weight": 400,
      "style": "italic",
      "fileId": "7ddd9658a57d7c58",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "inter",
      "weight": 500,
      "style": "italic",
      "fileId": "7ddd9658a57d7c58",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "inter",
      "weight": 600,
      "style": "italic",
      "fileId": "7ddd9658a57d7c58",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "inter",
      "weight": 700,
      "style": "italic",
      "fileId": "7ddd9658a57d7c58",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "inter",
      "weight": 400,
      "style": "normal",
      "fileId": "c940764593d0fe5d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "inter",
      "weight": 500,
      "style": "normal",
      "fileId": "c940764593d0fe5d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "inter",
      "weight": 600,
      "style": "normal",
      "fileId": "c940764593d0fe5d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "inter",
      "weight": 700,
      "style": "normal",
      "fileId": "c940764593d0fe5d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "jetbrains-mono",
      "weight": 400,
      "style": "italic",
      "fileId": "e3918da535efc38e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "jetbrains-mono",
      "weight": 500,
      "style": "italic",
      "fileId": "e3918da535efc38e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "jetbrains-mono",
      "weight": 400,
      "style": "normal",
      "fileId": "2c32b9b3ee358c11",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "jetbrains-mono",
      "weight": 500,
      "style": "normal",
      "fileId": "2c32b9b3ee358c11",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "kalam",
      "weight": 300,
      "style": "normal",
      "fileId": "94709c14e53e9ac9",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "kalam",
      "weight": 400,
      "style": "normal",
      "fileId": "257f0129d54c60cd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "kalam",
      "weight": 700,
      "style": "normal",
      "fileId": "c1bc5092263cb16e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "karla",
      "weight": 400,
      "style": "italic",
      "fileId": "e40d1dec9a7a8ada",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "karla",
      "weight": 500,
      "style": "italic",
      "fileId": "e40d1dec9a7a8ada",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "karla",
      "weight": 600,
      "style": "italic",
      "fileId": "e40d1dec9a7a8ada",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "karla",
      "weight": 400,
      "style": "normal",
      "fileId": "690fabf2f17b4a98",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "karla",
      "weight": 500,
      "style": "normal",
      "fileId": "690fabf2f17b4a98",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "karla",
      "weight": 600,
      "style": "normal",
      "fileId": "690fabf2f17b4a98",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lato",
      "weight": 300,
      "style": "italic",
      "fileId": "557b2ebbaa821105",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lato",
      "weight": 400,
      "style": "italic",
      "fileId": "5c3360f8439a1a3f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lato",
      "weight": 700,
      "style": "italic",
      "fileId": "4b833d8ce706a334",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lato",
      "weight": 300,
      "style": "normal",
      "fileId": "7bb29c58eadc0f0c",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lato",
      "weight": 400,
      "style": "normal",
      "fileId": "d4ae5188a65370ec",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lato",
      "weight": 700,
      "style": "normal",
      "fileId": "7a7ce1a34f3e9944",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lexend",
      "weight": 400,
      "style": "normal",
      "fileId": "1ec8f6ee2750554b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lexend",
      "weight": 500,
      "style": "normal",
      "fileId": "1ec8f6ee2750554b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lexend",
      "weight": 600,
      "style": "normal",
      "fileId": "1ec8f6ee2750554b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lexend",
      "weight": 700,
      "style": "normal",
      "fileId": "1ec8f6ee2750554b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "libre-baskerville",
      "weight": 400,
      "style": "italic",
      "fileId": "a4a7031f5c5283f8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "libre-baskerville",
      "weight": 700,
      "style": "italic",
      "fileId": "a4a7031f5c5283f8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "libre-baskerville",
      "weight": 400,
      "style": "normal",
      "fileId": "b62b98ef69e6e55b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "libre-baskerville",
      "weight": 700,
      "style": "normal",
      "fileId": "b62b98ef69e6e55b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lilita-one",
      "weight": 400,
      "style": "normal",
      "fileId": "8d6cd0f298738a92",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lobster",
      "weight": 400,
      "style": "normal",
      "fileId": "91f29167fda1cb92",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lora",
      "weight": 400,
      "style": "italic",
      "fileId": "3d536d49566e82a7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lora",
      "weight": 500,
      "style": "italic",
      "fileId": "3d536d49566e82a7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lora",
      "weight": 600,
      "style": "italic",
      "fileId": "3d536d49566e82a7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lora",
      "weight": 700,
      "style": "italic",
      "fileId": "3d536d49566e82a7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lora",
      "weight": 400,
      "style": "normal",
      "fileId": "6b102ab35aa1f2b3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lora",
      "weight": 500,
      "style": "normal",
      "fileId": "6b102ab35aa1f2b3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lora",
      "weight": 600,
      "style": "normal",
      "fileId": "6b102ab35aa1f2b3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "lora",
      "weight": 700,
      "style": "normal",
      "fileId": "6b102ab35aa1f2b3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "luckiest-guy",
      "weight": 400,
      "style": "normal",
      "fileId": "e463777d6d8013e0",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "manrope",
      "weight": 400,
      "style": "normal",
      "fileId": "e310b55a7fd9677f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "manrope",
      "weight": 500,
      "style": "normal",
      "fileId": "e310b55a7fd9677f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "manrope",
      "weight": 600,
      "style": "normal",
      "fileId": "e310b55a7fd9677f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "manrope",
      "weight": 700,
      "style": "normal",
      "fileId": "e310b55a7fd9677f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "merriweather",
      "weight": 400,
      "style": "italic",
      "fileId": "a81373d3b74e7a7b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "merriweather",
      "weight": 700,
      "style": "italic",
      "fileId": "a81373d3b74e7a7b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "merriweather",
      "weight": 400,
      "style": "normal",
      "fileId": "af1be39e2ff60ede",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "merriweather",
      "weight": 700,
      "style": "normal",
      "fileId": "af1be39e2ff60ede",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "montserrat",
      "weight": 400,
      "style": "italic",
      "fileId": "86589d0b59b31171",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "montserrat",
      "weight": 500,
      "style": "italic",
      "fileId": "86589d0b59b31171",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "montserrat",
      "weight": 600,
      "style": "italic",
      "fileId": "86589d0b59b31171",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "montserrat",
      "weight": 700,
      "style": "italic",
      "fileId": "86589d0b59b31171",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "montserrat",
      "weight": 800,
      "style": "italic",
      "fileId": "86589d0b59b31171",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "montserrat",
      "weight": 400,
      "style": "normal",
      "fileId": "6438d7b8ea9c7c39",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "montserrat",
      "weight": 500,
      "style": "normal",
      "fileId": "6438d7b8ea9c7c39",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "montserrat",
      "weight": 600,
      "style": "normal",
      "fileId": "6438d7b8ea9c7c39",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "montserrat",
      "weight": 700,
      "style": "normal",
      "fileId": "6438d7b8ea9c7c39",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "montserrat",
      "weight": 800,
      "style": "normal",
      "fileId": "6438d7b8ea9c7c39",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "mulish",
      "weight": 400,
      "style": "italic",
      "fileId": "59b79338a0889d12",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "mulish",
      "weight": 500,
      "style": "italic",
      "fileId": "59b79338a0889d12",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "mulish",
      "weight": 600,
      "style": "italic",
      "fileId": "59b79338a0889d12",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "mulish",
      "weight": 700,
      "style": "italic",
      "fileId": "59b79338a0889d12",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "mulish",
      "weight": 400,
      "style": "normal",
      "fileId": "14cc0eabadfeb1af",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "mulish",
      "weight": 500,
      "style": "normal",
      "fileId": "14cc0eabadfeb1af",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "mulish",
      "weight": 600,
      "style": "normal",
      "fileId": "14cc0eabadfeb1af",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "mulish",
      "weight": 700,
      "style": "normal",
      "fileId": "14cc0eabadfeb1af",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito",
      "weight": 400,
      "style": "italic",
      "fileId": "60ad29f2b640800b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito",
      "weight": 600,
      "style": "italic",
      "fileId": "60ad29f2b640800b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito",
      "weight": 700,
      "style": "italic",
      "fileId": "60ad29f2b640800b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito",
      "weight": 400,
      "style": "normal",
      "fileId": "20fc9b6fc618e7c3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito",
      "weight": 600,
      "style": "normal",
      "fileId": "20fc9b6fc618e7c3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito",
      "weight": 700,
      "style": "normal",
      "fileId": "20fc9b6fc618e7c3",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito-sans",
      "weight": 400,
      "style": "italic",
      "fileId": "bd5645075f472696",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito-sans",
      "weight": 500,
      "style": "italic",
      "fileId": "bd5645075f472696",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito-sans",
      "weight": 600,
      "style": "italic",
      "fileId": "bd5645075f472696",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito-sans",
      "weight": 700,
      "style": "italic",
      "fileId": "bd5645075f472696",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito-sans",
      "weight": 400,
      "style": "normal",
      "fileId": "39184f4d011106f5",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito-sans",
      "weight": 500,
      "style": "normal",
      "fileId": "39184f4d011106f5",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito-sans",
      "weight": 600,
      "style": "normal",
      "fileId": "39184f4d011106f5",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "nunito-sans",
      "weight": 700,
      "style": "normal",
      "fileId": "39184f4d011106f5",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "open-sans",
      "weight": 400,
      "style": "italic",
      "fileId": "8df90accd45bfd23",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "open-sans",
      "weight": 500,
      "style": "italic",
      "fileId": "8df90accd45bfd23",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "open-sans",
      "weight": 600,
      "style": "italic",
      "fileId": "8df90accd45bfd23",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "open-sans",
      "weight": 700,
      "style": "italic",
      "fileId": "8df90accd45bfd23",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "open-sans",
      "weight": 400,
      "style": "normal",
      "fileId": "441af0def989ebfd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "open-sans",
      "weight": 500,
      "style": "normal",
      "fileId": "441af0def989ebfd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "open-sans",
      "weight": 600,
      "style": "normal",
      "fileId": "441af0def989ebfd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "open-sans",
      "weight": 700,
      "style": "normal",
      "fileId": "441af0def989ebfd",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "oswald",
      "weight": 400,
      "style": "normal",
      "fileId": "9dde3797547520f7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "oswald",
      "weight": 700,
      "style": "normal",
      "fileId": "9dde3797547520f7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "outfit",
      "weight": 400,
      "style": "normal",
      "fileId": "92684e4acde79ef0",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "outfit",
      "weight": 500,
      "style": "normal",
      "fileId": "92684e4acde79ef0",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "outfit",
      "weight": 600,
      "style": "normal",
      "fileId": "92684e4acde79ef0",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "outfit",
      "weight": 700,
      "style": "normal",
      "fileId": "92684e4acde79ef0",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "pacifico",
      "weight": 400,
      "style": "normal",
      "fileId": "1a47a54e53bbfd3c",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "patrick-hand",
      "weight": 400,
      "style": "normal",
      "fileId": "42156e008dd5fc30",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "patua-one",
      "weight": 400,
      "style": "normal",
      "fileId": "1d8f4646c42ec4ed",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "permanent-marker",
      "weight": 400,
      "style": "normal",
      "fileId": "37202f2915830dbf",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "playfair-display",
      "weight": 400,
      "style": "italic",
      "fileId": "c68530044e7c4ce6",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "playfair-display",
      "weight": 500,
      "style": "italic",
      "fileId": "c68530044e7c4ce6",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "playfair-display",
      "weight": 600,
      "style": "italic",
      "fileId": "c68530044e7c4ce6",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "playfair-display",
      "weight": 700,
      "style": "italic",
      "fileId": "c68530044e7c4ce6",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "playfair-display",
      "weight": 400,
      "style": "normal",
      "fileId": "5d91eb5d522a0308",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "playfair-display",
      "weight": 500,
      "style": "normal",
      "fileId": "5d91eb5d522a0308",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "playfair-display",
      "weight": 600,
      "style": "normal",
      "fileId": "5d91eb5d522a0308",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "playfair-display",
      "weight": 700,
      "style": "normal",
      "fileId": "5d91eb5d522a0308",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "plus-jakarta-sans",
      "weight": 400,
      "style": "italic",
      "fileId": "f7f3c763fa674935",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "plus-jakarta-sans",
      "weight": 500,
      "style": "italic",
      "fileId": "f7f3c763fa674935",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "plus-jakarta-sans",
      "weight": 600,
      "style": "italic",
      "fileId": "f7f3c763fa674935",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "plus-jakarta-sans",
      "weight": 700,
      "style": "italic",
      "fileId": "f7f3c763fa674935",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "plus-jakarta-sans",
      "weight": 400,
      "style": "normal",
      "fileId": "cd8db90cd950e26b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "plus-jakarta-sans",
      "weight": 500,
      "style": "normal",
      "fileId": "cd8db90cd950e26b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "plus-jakarta-sans",
      "weight": 600,
      "style": "normal",
      "fileId": "cd8db90cd950e26b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "plus-jakarta-sans",
      "weight": 700,
      "style": "normal",
      "fileId": "cd8db90cd950e26b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "poppins",
      "weight": 400,
      "style": "italic",
      "fileId": "4eaac5c96bd47f9f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "poppins",
      "weight": 500,
      "style": "italic",
      "fileId": "dace3f9d671eae07",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "poppins",
      "weight": 600,
      "style": "italic",
      "fileId": "b9e0b57083ed1749",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "poppins",
      "weight": 700,
      "style": "italic",
      "fileId": "54c799453c6f2cc8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "poppins",
      "weight": 400,
      "style": "normal",
      "fileId": "3dc5d0c52428fe16",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "poppins",
      "weight": 500,
      "style": "normal",
      "fileId": "289e0afc8be731a8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "poppins",
      "weight": 600,
      "style": "normal",
      "fileId": "872e862918591a9e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "poppins",
      "weight": 700,
      "style": "normal",
      "fileId": "197a3cbd7290c242",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "pt-serif",
      "weight": 400,
      "style": "italic",
      "fileId": "219a8e6238f7f0b4",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "pt-serif",
      "weight": 700,
      "style": "italic",
      "fileId": "c4ccc041f7601de4",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "pt-serif",
      "weight": 400,
      "style": "normal",
      "fileId": "202b8aa6108ec44b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "pt-serif",
      "weight": 700,
      "style": "normal",
      "fileId": "57d3ae6c4b78cc2d",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "quicksand",
      "weight": 400,
      "style": "normal",
      "fileId": "1b092c711df1c7ad",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "quicksand",
      "weight": 500,
      "style": "normal",
      "fileId": "1b092c711df1c7ad",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "quicksand",
      "weight": 600,
      "style": "normal",
      "fileId": "1b092c711df1c7ad",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "quicksand",
      "weight": 700,
      "style": "normal",
      "fileId": "1b092c711df1c7ad",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "raleway",
      "weight": 400,
      "style": "italic",
      "fileId": "aadf99b189915dd8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "raleway",
      "weight": 500,
      "style": "italic",
      "fileId": "aadf99b189915dd8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "raleway",
      "weight": 600,
      "style": "italic",
      "fileId": "aadf99b189915dd8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "raleway",
      "weight": 400,
      "style": "normal",
      "fileId": "10f1a0ef3f349790",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "raleway",
      "weight": 500,
      "style": "normal",
      "fileId": "10f1a0ef3f349790",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "raleway",
      "weight": 600,
      "style": "normal",
      "fileId": "10f1a0ef3f349790",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "righteous",
      "weight": 400,
      "style": "normal",
      "fileId": "17bb3e21ead29ad2",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto",
      "weight": 400,
      "style": "italic",
      "fileId": "9f06741ff731c455",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto",
      "weight": 500,
      "style": "italic",
      "fileId": "9f06741ff731c455",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto",
      "weight": 600,
      "style": "italic",
      "fileId": "9f06741ff731c455",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto",
      "weight": 700,
      "style": "italic",
      "fileId": "9f06741ff731c455",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto",
      "weight": 400,
      "style": "normal",
      "fileId": "0a44e0bb6ba5c853",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto",
      "weight": 500,
      "style": "normal",
      "fileId": "0a44e0bb6ba5c853",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto",
      "weight": 600,
      "style": "normal",
      "fileId": "0a44e0bb6ba5c853",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto",
      "weight": 700,
      "style": "normal",
      "fileId": "0a44e0bb6ba5c853",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto-mono",
      "weight": 400,
      "style": "italic",
      "fileId": "52cf6d1b27b1fd0e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto-mono",
      "weight": 500,
      "style": "italic",
      "fileId": "52cf6d1b27b1fd0e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto-mono",
      "weight": 400,
      "style": "normal",
      "fileId": "2ed6ac9efae6d21f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "roboto-mono",
      "weight": 500,
      "style": "normal",
      "fileId": "2ed6ac9efae6d21f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "rubik",
      "weight": 400,
      "style": "italic",
      "fileId": "664ffdbebe50f73b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "rubik",
      "weight": 500,
      "style": "italic",
      "fileId": "664ffdbebe50f73b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "rubik",
      "weight": 600,
      "style": "italic",
      "fileId": "664ffdbebe50f73b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "rubik",
      "weight": 700,
      "style": "italic",
      "fileId": "664ffdbebe50f73b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "rubik",
      "weight": 400,
      "style": "normal",
      "fileId": "99ec7ccb40cf143f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "rubik",
      "weight": 500,
      "style": "normal",
      "fileId": "99ec7ccb40cf143f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "rubik",
      "weight": 600,
      "style": "normal",
      "fileId": "99ec7ccb40cf143f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "rubik",
      "weight": 700,
      "style": "normal",
      "fileId": "99ec7ccb40cf143f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "russo-one",
      "weight": 400,
      "style": "normal",
      "fileId": "53c9adb058b01d01",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "sacramento",
      "weight": 400,
      "style": "normal",
      "fileId": "7b80b397783c2b2b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "satisfy",
      "weight": 400,
      "style": "normal",
      "fileId": "a690e9f39fdd13e0",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "shadows-into-light",
      "weight": 400,
      "style": "normal",
      "fileId": "61cb1fd4967e283a",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "sora",
      "weight": 400,
      "style": "normal",
      "fileId": "3902474d3ece89c8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "sora",
      "weight": 500,
      "style": "normal",
      "fileId": "3902474d3ece89c8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "sora",
      "weight": 600,
      "style": "normal",
      "fileId": "3902474d3ece89c8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "sora",
      "weight": 700,
      "style": "normal",
      "fileId": "3902474d3ece89c8",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-code-pro",
      "weight": 400,
      "style": "italic",
      "fileId": "68b55e7814164bdc",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-code-pro",
      "weight": 500,
      "style": "italic",
      "fileId": "68b55e7814164bdc",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-code-pro",
      "weight": 400,
      "style": "normal",
      "fileId": "2c935ccea0efa74f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-code-pro",
      "weight": 500,
      "style": "normal",
      "fileId": "2c935ccea0efa74f",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-sans-3",
      "weight": 400,
      "style": "italic",
      "fileId": "dba77455b9c18867",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-sans-3",
      "weight": 500,
      "style": "italic",
      "fileId": "dba77455b9c18867",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-sans-3",
      "weight": 600,
      "style": "italic",
      "fileId": "dba77455b9c18867",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-sans-3",
      "weight": 400,
      "style": "normal",
      "fileId": "ac057a5593cbe3df",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-sans-3",
      "weight": 500,
      "style": "normal",
      "fileId": "ac057a5593cbe3df",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-sans-3",
      "weight": 600,
      "style": "normal",
      "fileId": "ac057a5593cbe3df",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-serif-4",
      "weight": 400,
      "style": "italic",
      "fileId": "ad17ab41cc010420",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-serif-4",
      "weight": 500,
      "style": "italic",
      "fileId": "ad17ab41cc010420",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-serif-4",
      "weight": 600,
      "style": "italic",
      "fileId": "ad17ab41cc010420",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-serif-4",
      "weight": 700,
      "style": "italic",
      "fileId": "ad17ab41cc010420",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-serif-4",
      "weight": 400,
      "style": "normal",
      "fileId": "286e05e5e444f44e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-serif-4",
      "weight": 500,
      "style": "normal",
      "fileId": "286e05e5e444f44e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-serif-4",
      "weight": 600,
      "style": "normal",
      "fileId": "286e05e5e444f44e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "source-serif-4",
      "weight": 700,
      "style": "normal",
      "fileId": "286e05e5e444f44e",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "space-grotesk",
      "weight": 400,
      "style": "normal",
      "fileId": "a0d054c4af557de2",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "space-grotesk",
      "weight": 500,
      "style": "normal",
      "fileId": "a0d054c4af557de2",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "space-grotesk",
      "weight": 600,
      "style": "normal",
      "fileId": "a0d054c4af557de2",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "space-grotesk",
      "weight": 700,
      "style": "normal",
      "fileId": "a0d054c4af557de2",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "space-mono",
      "weight": 400,
      "style": "italic",
      "fileId": "7b001804bf97cfe4",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "space-mono",
      "weight": 700,
      "style": "italic",
      "fileId": "bb03cb70d44305b6",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "space-mono",
      "weight": 400,
      "style": "normal",
      "fileId": "e0c8e616bda27642",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "space-mono",
      "weight": 700,
      "style": "normal",
      "fileId": "af7cf6d2b897ec45",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "spectral",
      "weight": 400,
      "style": "italic",
      "fileId": "7cfafd3583aecfe2",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "spectral",
      "weight": 500,
      "style": "italic",
      "fileId": "a0533b33ddd6bedf",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "spectral",
      "weight": 600,
      "style": "italic",
      "fileId": "8d4f3594c930ffab",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "spectral",
      "weight": 700,
      "style": "italic",
      "fileId": "1fdd59a028cceea6",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "spectral",
      "weight": 400,
      "style": "normal",
      "fileId": "bcb83e9c56d40c51",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "spectral",
      "weight": 500,
      "style": "normal",
      "fileId": "79ce505722da87b9",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "spectral",
      "weight": 600,
      "style": "normal",
      "fileId": "1fb6ca29fc243e8b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "spectral",
      "weight": 700,
      "style": "normal",
      "fileId": "1125ec621f11c866",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "titan-one",
      "weight": 400,
      "style": "normal",
      "fileId": "f5f3f60e9246f7e7",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "ubuntu-mono",
      "weight": 400,
      "style": "italic",
      "fileId": "6630a8d5ec2bf8da",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "ubuntu-mono",
      "weight": 700,
      "style": "italic",
      "fileId": "83a138fc2854ace0",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "ubuntu-mono",
      "weight": 400,
      "style": "normal",
      "fileId": "646f2d4b83b5ea2c",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "ubuntu-mono",
      "weight": 700,
      "style": "normal",
      "fileId": "d908c86a05dde68b",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "work-sans",
      "weight": 400,
      "style": "italic",
      "fileId": "b87f48add7ec3052",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "work-sans",
      "weight": 500,
      "style": "italic",
      "fileId": "b87f48add7ec3052",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "work-sans",
      "weight": 600,
      "style": "italic",
      "fileId": "b87f48add7ec3052",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "work-sans",
      "weight": 400,
      "style": "normal",
      "fileId": "72cd8f67849cc714",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "work-sans",
      "weight": 500,
      "style": "normal",
      "fileId": "72cd8f67849cc714",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    },
    {
      "familyId": "work-sans",
      "weight": 600,
      "style": "normal",
      "fileId": "72cd8f67849cc714",
      "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
    }
  ],
  "licenses": [
    {
      "familyId": "abril-fatface",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Abril+Fatface"
    },
    {
      "familyId": "alfa-slab-one",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Alfa+Slab+One"
    },
    {
      "familyId": "anton",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Anton"
    },
    {
      "familyId": "archivo-black",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Archivo+Black"
    },
    {
      "familyId": "assistant",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Assistant"
    },
    {
      "familyId": "atkinson-hyperlegible",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Atkinson+Hyperlegible"
    },
    {
      "familyId": "baloo-2",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Baloo+2"
    },
    {
      "familyId": "bangers",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Bangers"
    },
    {
      "familyId": "barlow",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Barlow"
    },
    {
      "familyId": "bebas-neue",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Bebas+Neue"
    },
    {
      "familyId": "bitter",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Bitter"
    },
    {
      "familyId": "bubblegum-sans",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Bubblegum+Sans"
    },
    {
      "familyId": "cabin",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Cabin"
    },
    {
      "familyId": "cardo",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Cardo"
    },
    {
      "familyId": "caveat",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Caveat"
    },
    {
      "familyId": "chewy",
      "license": "Apache-2.0",
      "sourceUrl": "https://fonts.google.com/specimen/Chewy"
    },
    {
      "familyId": "cinzel",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Cinzel"
    },
    {
      "familyId": "comfortaa",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Comfortaa"
    },
    {
      "familyId": "concert-one",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Concert+One"
    },
    {
      "familyId": "cormorant-garamond",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Cormorant+Garamond"
    },
    {
      "familyId": "creepster",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Creepster"
    },
    {
      "familyId": "crimson-pro",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Crimson+Pro"
    },
    {
      "familyId": "dancing-script",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Dancing+Script"
    },
    {
      "familyId": "dm-mono",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/DM+Mono"
    },
    {
      "familyId": "dm-sans",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/DM+Sans"
    },
    {
      "familyId": "eb-garamond",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/EB+Garamond"
    },
    {
      "familyId": "fira-code",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Fira+Code"
    },
    {
      "familyId": "fragment-mono",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Fragment+Mono"
    },
    {
      "familyId": "fredoka",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Fredoka"
    },
    {
      "familyId": "great-vibes",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Great+Vibes"
    },
    {
      "familyId": "ibm-plex-mono",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/IBM+Plex+Mono"
    },
    {
      "familyId": "inconsolata",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Inconsolata"
    },
    {
      "familyId": "indie-flower",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Indie+Flower"
    },
    {
      "familyId": "inter",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Inter"
    },
    {
      "familyId": "jetbrains-mono",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/JetBrains+Mono"
    },
    {
      "familyId": "kalam",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Kalam"
    },
    {
      "familyId": "karla",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Karla"
    },
    {
      "familyId": "lato",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Lato"
    },
    {
      "familyId": "lexend",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Lexend"
    },
    {
      "familyId": "libre-baskerville",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Libre+Baskerville"
    },
    {
      "familyId": "lilita-one",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Lilita+One"
    },
    {
      "familyId": "lobster",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Lobster"
    },
    {
      "familyId": "lora",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Lora"
    },
    {
      "familyId": "luckiest-guy",
      "license": "Apache-2.0",
      "sourceUrl": "https://fonts.google.com/specimen/Luckiest+Guy"
    },
    {
      "familyId": "manrope",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Manrope"
    },
    {
      "familyId": "merriweather",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Merriweather"
    },
    {
      "familyId": "montserrat",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Montserrat"
    },
    {
      "familyId": "mulish",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Mulish"
    },
    {
      "familyId": "nunito",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Nunito"
    },
    {
      "familyId": "nunito-sans",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Nunito+Sans"
    },
    {
      "familyId": "open-sans",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Open+Sans"
    },
    {
      "familyId": "oswald",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Oswald"
    },
    {
      "familyId": "outfit",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Outfit"
    },
    {
      "familyId": "pacifico",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Pacifico"
    },
    {
      "familyId": "patrick-hand",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Patrick+Hand"
    },
    {
      "familyId": "patua-one",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Patua+One"
    },
    {
      "familyId": "permanent-marker",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Permanent+Marker"
    },
    {
      "familyId": "playfair-display",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Playfair+Display"
    },
    {
      "familyId": "plus-jakarta-sans",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Plus+Jakarta+Sans"
    },
    {
      "familyId": "poppins",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Poppins"
    },
    {
      "familyId": "pt-serif",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/PT+Serif"
    },
    {
      "familyId": "quicksand",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Quicksand"
    },
    {
      "familyId": "raleway",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Raleway"
    },
    {
      "familyId": "righteous",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Righteous"
    },
    {
      "familyId": "roboto",
      "license": "Apache-2.0",
      "sourceUrl": "https://fonts.google.com/specimen/Roboto"
    },
    {
      "familyId": "roboto-mono",
      "license": "Apache-2.0",
      "sourceUrl": "https://fonts.google.com/specimen/Roboto+Mono"
    },
    {
      "familyId": "rubik",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Rubik"
    },
    {
      "familyId": "russo-one",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Russo+One"
    },
    {
      "familyId": "sacramento",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Sacramento"
    },
    {
      "familyId": "satisfy",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Satisfy"
    },
    {
      "familyId": "shadows-into-light",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Shadows+Into+Light"
    },
    {
      "familyId": "sora",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Sora"
    },
    {
      "familyId": "source-code-pro",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Source+Code+Pro"
    },
    {
      "familyId": "source-sans-3",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Source+Sans+3"
    },
    {
      "familyId": "source-serif-4",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Source+Serif+4"
    },
    {
      "familyId": "space-grotesk",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Space+Grotesk"
    },
    {
      "familyId": "space-mono",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Space+Mono"
    },
    {
      "familyId": "spectral",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Spectral"
    },
    {
      "familyId": "titan-one",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Titan+One"
    },
    {
      "familyId": "ubuntu-mono",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Ubuntu+Mono"
    },
    {
      "familyId": "work-sans",
      "license": "OFL",
      "sourceUrl": "https://fonts.google.com/specimen/Work+Sans"
    }
  ]
}
